
import React, {Fragment,useState, useEffect} from 'react'
import axios from 'axios';
import { useHistory } from "react-router-dom";

export const Filtro = (props) => {
    const history = useHistory();
    const [etiquetasEvento, setEtiquetasEvento] = useState(false)

   

    const fetchEtiquetas = async () => {
        let dataFormEventos = {  
            "tipoCategoria": "etiqueta"
         }
        
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':`Bearer ${localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-token`)}`
            },  
        };
        axios.post(`${process.env.REACT_APP_URL_API}formatos/ObtenerCategorias`, dataFormEventos, axiosConfig)
        .then((res) => {
        
            setEtiquetasEvento(res.data.data)
        })
        .catch((err) => {
            
        }) 
    }

    useEffect(() => {
        fetchEtiquetas();
    },[])

    const novigateTo = (e) => {
        e.target.value != '-1' ?
        history.push(`/etiqueta/${e.target.value}`)
        :
        history.push(`/`)
    }

    if(!etiquetasEvento) { return(<div></div>) }   
    return  (
        <Fragment>
            <div className="buscador">
                <div className="label-buscador">Encuentra contenidos según tus intereses</div>
                    <select className="form-control"  onChange={(e) =>  novigateTo(e)}>
                        <option value='-1'>Todos</option>
                        {
                            etiquetasEvento.map(item => <option key={`cat-${item.idCategoria}`} value={item.idCategoria}>{item.descripcion}</option>)
                        }
                        
                    </select>
                </div>
        </Fragment> 
    )
    
}
